module.exports = __webpack_public_path__ + "img/Grafana.ec8d76d.svg";